import React from "react";
import "./PageNotFound.css";
import { Link } from "react-router-dom";
const PageNotFound = () => {
  return (
    <>
      <div className="notfoundcontainer">
        <div className="d-flex justify-content-center align-items-center">
          <div className="section text-center">
            <h1 className="error ">404</h1>
            <div className="page text-light">
              Ooops!!! The page you are looking for is not found
            </div>
            <div className="">
              <Link className="back-home bg-light " to={'user'}>
                Back to home
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PageNotFound;
